module.exports = __webpack_public_path__ + "img/rock.52503823.png";